import { environment } from '@app-env/environment';

import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import type { BrowserOptions } from '@sentry/angular';

export const SENTRY_CONFIG = {
	dsn: environment.SERVICE_SENTRY_DSN_PUBLIC,
	environment: environment.APP_ENV,
	release: environment.COMMIT_HASH.substr(0, 8),
	beforeSend: (event, hint) => {
		if (hint) {
			const error = hint?.originalException;
			let errorMessage: string | undefined;
			if (typeof error === 'string') {
				errorMessage = error;
			} else if (error instanceof Error) {
				errorMessage = error.message;
			}
			if (typeof errorMessage === 'string') {
				const tests: (string | RegExp)[] = [/^Timeout/, /^Uncaught \(in promise\): Timeout/, /^Non-Error promise rejection captured with value: Timeout/];
				if (tests.some(test => errorMessage?.match(test))) return null;
			}
		}
		return event;
	},
	ignoreErrors: [
		// Random plugins/extensions
		'top.GLOBALS',
		// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
		'originalCreateNotification',
		'canvas.contentDocument',
		'MyApp_RemoveAllHighlights',
		'http://tt.epicplay.com',
		"Can't find variable: ZiteReader",
		'jigsaw is not defined',
		'ComboSearch is not defined',
		'http://loading.retry.widdit.com/',
		'atomicFindClose',
		// Facebook borked
		'fb_xd_fragment',
		// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
		// reduce this. (thanks @acdha)
		// See http://stackoverflow.com/questions/4113268
		'bmi_SafeAddOnload',
		'EBCallBackMessageReceived',
		// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
		'conduitPage',
	],
	denyUrls: [
		// Facebook flakiness
		/graph\.facebook\.com/i,
		/connect\.facebook\.net/i,
		// Ignore Google flakiness
		/\/(gtm|ga|analytics)\.js/i,
		/www\.gstatic\.com/i,
		// Woopra flakiness
		/eatdifferent\.com\.woopra-ns\.com/i,
		/static\.woopra\.com\/js\/woopra\.js/i,
		// Chrome extensions
		/extensions\//i,
		/^chrome:\/\//i,
		// Firefox extensions
		/^resource:\/\//i,
		// Other plugins
		/127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
		/webappstoolbarba\.texthelp\.com\//i,
		/metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
	],

	integrations: [
		// Registers and configures the Tracing integration,
		// which automatically instruments your application to monitor its
		// performance, including custom Angular routing instrumentation
		new Integrations.BrowserTracing({
			// tracingOrigins: ["localhost", "https://yourserver.io/api"],
			routingInstrumentation: Sentry.routingInstrumentation,
		}),
	],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 0.1,
} as BrowserOptions;
